import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Employee, SalaryParameter } from '../employees';
import { EmployeeSearch } from '../employees/employee-list/model/employee-search.model';
import { SchoolService } from './school.service';
import { logRequest } from 'app/main/shared/http-utils';

@Injectable({
    providedIn: 'root',
})
export class SalaryParameterService {
    baseUrl = '/school-service/api/salary-parameter';

    constructor(
        private http: HttpClient,
        private schoolService: SchoolService
    ) {}

    search(employeeSearchDTO: EmployeeSearch): Observable<HttpResponse<SalaryParameter[]>> {
        if (!employeeSearchDTO.admin) {
            employeeSearchDTO.schoolId = this.schoolService.getActiveSchool().id;
        }
        return this.http.post<Employee[]>(`${this.baseUrl}/search`, employeeSearchDTO, { observe: 'response' });
    }

    getById(id: string): Observable<HttpResponse<SalaryParameter>> {
        return this.http.get<SalaryParameter>(`${this.baseUrl}/${id}`, { observe: 'response' });
    }

    update(salaryParameter: SalaryParameter): Observable<HttpResponse<SalaryParameter>> {
        return this.http.put<SalaryParameter>(this.baseUrl, salaryParameter, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    create(salaryParameter: SalaryParameter): Observable<HttpResponse<SalaryParameter>> {
        return this.http.post<SalaryParameter>(this.baseUrl, salaryParameter, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    delete(id: string): Observable<HttpResponse<SalaryParameter>> {
        return this.http.delete<SalaryParameter>(`${this.baseUrl}/${id}`, {
            observe: 'response',
            headers: logRequest(),
        });
    }
}
